<template>
  <el-header style="height: auto;">
    <el-container class="d-flex-center">
      <a @click="$router.push('/')" href="javascript:void(0);" class="nav-brand">
        <img alt="Maren Logo" class="logo" src="../../../public/img/logo.svg" width="120" />
      </a>
      <button @click="toggle" class="toggle-menu"><i class="icon-menu2"></i>
      </button>
      <ul class="menu-list" :class="open ? 'block': 'hidden'">
        <li class="menu-item">
          <router-link to="/aboutus" class="menu-link phone-call">About Us</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/products" class="menu-link phone-call">Products</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/our-team" class="menu-link phone-call">Our Team</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/awards-events" class="menu-link phone-call">Awards & Events</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/memories" class="menu-link phone-call">Memories</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/careers" class="menu-link phone-call">Careers</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/contactus" class="menu-link phone-call">Contact Us</router-link>
        </li>
        <!--<li v-if="route.path=='/' || route.path=='/aboutus' || route.path=='/contactus' || route.path=='/products' || route.path=='/our-team' || route.path=='/awards-events' || route.path=='/memories' || route.path=='/careers'" class="menu-item">
          <a href="javascript:void(0);" class="menu-link globe-icon menu-border">
            <el-dropdown trigger="click" :hide-on-click="headerDD">
              <span class="el-dropdown-link">
                <span :class="displayLang=='عربي' ? 'ar' : 'en'">{{ displayLang }}</span>
              <i class="icon-down-arrow"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="search-bar-dropd language">
                  <el-button type="text" :class="displayLang=='عربي' ? 'active' : ''" class="en" plain @click="changeLanguage('en')">English</el-button>
                  <el-button type="text" :class="displayLang=='English' ? 'active' : ''" class="ar" plain @click="changeLanguage('ar')" >Arabic</el-button>
              </el-dropdown-menu>
            </el-dropdown>
          </a>
        </li>--->
      </ul>
    </el-container>
  </el-header>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: mapGetters(["getAuth","getCurrency","getLang", "getCurrencyName"]),
  props: ["currency", "locale", "route"],
  data() {
    return {
      displayLang: 'English',
      
      renderLocale: {},
      cur: "",
      open: false,
      activeLink: null,
      headerDD: false,
      menuList: []
  }
  },
  watch: {
    locale: {
      immediate: true,
      handler() {
        if (this.locale) {
          this.renderLocale = this.locale;
          this.menuList = [
            {
              //iconname: "icon-flight-destination",
              menuname: this.renderLocale.flight,
              path: "/"
            }
          ]
        }
      }
    },
    getLang: {
      immediate: true,
      handler() {
        if(this.getLang == 'en') {
          this.displayLang = 'عربي'

        }
      }
    }
  },
  methods: {
    toggle() {
    	this.open = !this.open
    },
    async changeLanguage(lang) {
      await this.$store
        .dispatch("SET_CUST_LANGUAGE", lang)
        .then(this.$cookie.set('currentLang',lang))
        .then(this.$router.go());
      this.headerDD = true;
    }
  }
};
</script>




// WEBPACK FOOTER //
// Header.vue